import { Character } from '../../main/types/asset/character.types.ts';
import { getCharactersUtil } from '../../main/utils/asset/characters.util.ts';
import { createMemoizedSelector } from '../../main/utils/selector/create-memoized-selector.ts';

import { selectCurrentLessonTaskStep } from './current-lesson-task-step.selector.ts';

export const selectCurrentLessonCharacter = createMemoizedSelector(
  selectCurrentLessonTaskStep,
  (currentLessonTaskStep): Character => {
    const charactersUtil = getCharactersUtil();
    const character = currentLessonTaskStep.lesson.animalCharacterKey
      ? charactersUtil.getCharacter(currentLessonTaskStep.lesson.animalCharacterKey)
      : undefined;
    return character ?? charactersUtil.getDefaultCharacter();
  }
);
